<template>
    <div class="event-select-city">
        <custom-select :options="options" v-model="value" :name="name">
            {{ label }}
        </custom-select>
    </div>
</template>

<script>

import CustomSelect from '../../common/fields/custom-select';

export default {
    name: 'event-select-city',

    components: { CustomSelect },

    data() {
        return {
            value: null,
        };
    },

    props: {
        data: {
            type: Array,
        },

        label: {
            type: String,
        },

        name: {
            type: String,
        },
    },

    computed: {
        options() {
            const options = [];

            this.data.forEach((item) => {
                options.push({ value: item.VALUE, text: item.PRINT_VALUE });
            });

            return options;
        },
    },
};
</script>
